import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 6a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","fill":"currentColor","key":"svg-0"}],["path",{"d":"M11 18a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","fill":"currentColor","key":"svg-1"}],["path",{"d":"M5 12l14 0","key":"svg-2"}]]

const IconDivide = createReactComponent('outline', 'divide', 'Divide', __iconNode);

export default IconDivide;